import { render } from "./BalanceContainer.vue?vue&type=template&id=56a100bb&scoped=true"
import script from "./BalanceContainer.vue?vue&type=script&lang=js"
export * from "./BalanceContainer.vue?vue&type=script&lang=js"

import "./BalanceContainer.vue?vue&type=style&index=0&id=56a100bb&lang=scss&scoped=true"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a100bb"]])

export default __exports__